const checkoutUrl = "https://checkout.compendiumgeneeskunde.nl";
const cartJson = '/cart.js';
const onlyEasyPieCheckout = false;
const subscriptionPeriodAlert = "Let op: Voeg alleen abonnementen met dezelfde bezorgperiode toe aan je bestelling! (Bijvoorbeeld: 'om de 4 weken' en 'om de 6 weken' moeten in aparte bestellingen geplaatst worden.)";

function buyNowButton() {
    setTimeout(async function () {
        if (document.getElementById("cart-notification").classList.contains("active")) {
            await fetch(cartJson).then((res) => {
                return res.json();
            }).then((data) => {
                redirectUrl(data);
            });
        }
        else {
            buyNowButton();
        }
    }, 250);
}

document.addEventListener('DOMContentLoaded', async function () {
    var isDeliveryInternalDifferent = false;
    var redirectCheckout = true;
    var redirectCheckout2 = true;
    document.addEventListener('click', async function (e) {
        if ((e.target.getAttribute("id") && e.target.getAttribute("id") == "checkout") || (e.target.getAttribute("name") && e.target.getAttribute("name") == "checkout") || (e.target.parentElement?.getAttribute("name") && e.target.parentElement?.getAttribute("name") == "checkout") || (e.target.parentElement.parentElement?.getAttribute("name") && e.target.parentElement.parentElement?.getAttribute("name") == "checkout") || (e.target.parentElement.parentElement.parentElement?.getAttribute("name") && e.target.parentElement.parentElement.parentElement?.getAttribute("name") == "checkout") || (e.target.parentElement.parentElement.parentElement.parentElement?.getAttribute("name") && e.target.parentElement.parentElement.parentElement.parentElement?.getAttribute("name") == "checkout")) {
            if (redirectCheckout) {
                e.preventDefault();
                e.stopPropagation();
                await fetch(cartJson).then((res) => {
                    return res.json();
                }).then((data) => {
                    if (onlyEasyPieCheckout || cartHasSubscription(data)) {
                        redirectUrl(data);
                    }
                    else {
                        redirectCheckout = false;
                        e.target.click();
                    }
                });
            }
            else {
                redirectCheckout = true;
            }
        }
        else if (e.target.getAttribute("class") && e.target.getAttribute("class").includes('shopify-payment-button')) {
            if (redirectCheckout2) {
                e.preventDefault();
                e.stopPropagation();
                var radioButton = document.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) input[name^="purchaseOption"]:checked');
                if (onlyEasyPieCheckout || (radioButton && radioButton.getAttribute("data-radio-type") && radioButton.getAttribute("data-radio-type") == "selling_plan")) {
                    await fetch('/cart/clear.json', {
                        method: "POST",
                    }).then(async function () {
                        var timesClicked = 0;
                        document.querySelector('button[name="add"').click(function () {
                            timesClicked++;
                        });
                        if (timesClicked > 0) {
                            buyNowButton();
                        }
                        else {
                            document.querySelector('button[name="add"').click();
                            buyNowButton();
                        }
                    });
                }
                else {
                    redirectCheckout2 = false;
                    e.target.click();
                }
            }
            else {
                redirectCheckout2 = true;
            }
        }
        else if ((e.target.getAttribute("name") && e.target.getAttribute("name") == "add") || (e.target.parentElement?.getAttribute("name") && e.target.parentElement?.getAttribute("name") == "add") || (e.target.parentElement.parentElement?.getAttribute("name") && e.target.parentElement.parentElement?.getAttribute("name") == "add") || (e.target.parentElement.parentElement.parentElement?.getAttribute("name") && e.target.parentElement.parentElement.parentElement?.getAttribute("name") == "add") || (e.target.parentElement.parentElement.parentElement.parentElement?.getAttribute("name") && e.target.parentElement.parentElement.parentElement.parentElement?.getAttribute("name") == "add")) {
            if (!isDeliveryInternalDifferent) {
                e.preventDefault();
                e.stopPropagation();
                var radioButton = document.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) input[name^="purchaseOption"]:checked');
                if (radioButton && radioButton.getAttribute("data-radio-type") && radioButton.getAttribute("data-radio-type") == "selling_plan") {
                    await fetch(cartJson).then(async (res) => {
                        return await res.json();
                    }).then(async (data) => {
                        if (cartHasSubscription(data)) {
                            var sellingPlanName = radioButton.parentNode.innerText.trim();
                            var l1 = data.items.filter(x => x.selling_plan_allocation != null).length;
                            var l2 = data.items.filter(x => x.selling_plan_allocation != null).filter(x => x.selling_plan_allocation.selling_plan.name.split(',')[0] == sellingPlanName.split(',')[0]).length;
                            if (l1 != l2) {
                                alert(subscriptionPeriodAlert);
                            }
                            else {
                                isDeliveryInternalDifferent = true;
                                e.target.click();
                            }
                        }
                        else {
                            isDeliveryInternalDifferent = true;
                            e.target.click();
                        }
                    });
                }
                else {
                    isDeliveryInternalDifferent = true;
                    e.target.click();
                }
            }
            else {
                isDeliveryInternalDifferent = false;
            }
        }
    }, true);
});

function cartHasSubscription(data) {
    return data.items.some(i => i.selling_plan_allocation != null);
}

function redirectUrl(data) {
    gTrack(data);
    var currency = data.currency.toLowerCase();
    var currency2 = document.getElementsByClassName("wsscc-text")[0]?.textContent.trim().toLowerCase();
    var lcc = "/?lang=" + Shopify.locale + "&cur=" + (currency2 ?? currency) + "&cnt=" + Shopify.country + "&email=" + customerEmail.trim().toLowerCase(); 
    data = data.items;
    data = data.map(x => ({  cur: currency, qty: x.quantity, sbs: x.selling_plan_allocation?.selling_plan, id: x.variant_id, prc: x.final_price }));
    data.forEach(x => {
        if (x.sbs) {
            delete x.sbs.description;
            delete x.sbs.fixed_selling_plan;
            delete x.sbs.options;
            delete x.sbs.price_adjustments;
            delete x.sbs.recurring_deliveries;
        }
        else {
            delete x.sbs;
        }
    });
    window.location.href = checkoutUrl + lcc.toLowerCase() + "&cart=" + encodeURIComponent(JSON.stringify(data));
}

function gTrack(data)
{
    try {
        var lineItems = data.items;
        lineItems = lineItems.map(x => ({ item_id: x.variant_id, item_name: x.product_title, price: x.final_price / 100, quantity: x.quantity }));
        gtag("event", "begin_checkout", {
            currency: data.currrency,
            value: data.total_price / 100,
            items: lineItems,
        });
    }
    catch{ }
}